import { Component, OnInit, ViewChild } from "@angular/core";
import { I18nService } from "@app/core";
import { Title } from "@angular/platform-browser";
import { AuthService } from "@app/auth.service";
import { Router, NavigationEnd } from "@angular/router";
import { UserService } from "@app/user.service";
import { UtilService } from "@app/utility/util.service";
import { ApiService } from "@app/utility/api.service";
import { NotiService } from "@app/noti.service";
import { CryptographyService } from "@app/cryptography.service"

declare var $: any, gapi: any, FB: any, JSEncrypt: any

@Component({
  selector: "app-mainmenu",
  templateUrl: "./mainmenu.component.html",
  styleUrls: ["./mainmenu.component.scss"],
})
export class MainmenuComponent implements OnInit {
  menuStr: any;
  member_info: any;
  IsSelect: any;
  isCrisis = true

  config: any
  cookieData: any = {}

  isLoggedIn = false
  firstname = ""
  lastname = ""

  notiList: any = []
  dict: any = {};

  UnreadCount: number = 0;

  contactId = ""
  imgProfileSrc = ""

  menuList: any

  lang = "th"

  simulateMenu: any = {}
  contactDpaMenu: any = {}
  faqMenu: any = {}
  loginMenu: any = {}
  trackStatusMenu: any = {}
  inquiryMenu: any = {}
  reqNewDocMenu: any = {}
  statusReqNewDocMenu: any = {}
  banklistMenu: any = {}
  aboutUsMenu: any = {}
  fbLoginBtn: any = {}
  lineLoginBtn: any = {}
  googleLoginBtn: any = {}
  regisMenu: any = {}
  logoutMenu: any = {}
  
  constructor(
    private i18nService: I18nService,
    private titleService: Title,
    private Auth: AuthService,
    private router: Router,
    private user: UserService,
    private util: UtilService,
    private apiService: ApiService,
    private notiService: NotiService,
    private crypto: CryptographyService
  ) {
    router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        this.InitText(val.url);
        let ActivatedComponent = val.url.substring(val.url.lastIndexOf('/') + 1, val.url.length);
        if (ActivatedComponent.toLocaleLowerCase() != "refunddeposits") {
          let CookieData: any = localStorage.getItem("dpa_portal");
          if (CookieData != null && CookieData != "") {
            CookieData = JSON.parse(CookieData);
            CookieData.refundState = "";
            localStorage.setItem("dpa_portal", JSON.stringify(CookieData));
          }
        }
      }
    });
  }

  async ngOnInit() {
    const thisTs = this;
    this.util.ShowWaiting(true)

    let ck: any = JSON.parse(localStorage.getItem("dpa_portal"))

    if (ck == null) {
      localStorage.setItem("dpa_portal", "{}")
      this.cookieData = {}
    }
    else {
      this.cookieData = ck
    }

    if (this.cookieData != null && this.cookieData.contactid != null && this.cookieData.contactid.trim().length != 0) {
      this.isLoggedIn = true
      if(this.cookieData.lang == null || this.cookieData.lang == ""){
        this.cookieData.lang = "th-TH"
      }
    }
    else {
      this.isLoggedIn = false
      this.cookieData.lang = "th-TH"
    }
    
    this.notiService.langChange(this.cookieData.lang.substring(0,2));
    this.setLanguage(this.cookieData.lang)

    this.config = await this.apiService.get("master", "configuration")
    let crisisConfig: any = this.config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      this.isCrisis = true
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }
    else {
      this.cookieData.isCrisis = false
      this.isCrisis = false

      this.isLoggedIn = false
      this.firstname = ""
      this.lastname = ""
      this.contactId = ""
      this.imgProfileSrc = ""

      this.cookieData.firstname = this.firstname
      this.cookieData.lastname = this.lastname
      this.cookieData.contactid = this.contactId
      
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }

    await this.getUserLoggedIn()

    this.menuList = await this.apiService.get("master", "customerPortalMenuSetting")

    this.simulateMenu = this.util.getMenuObj(this.menuList, "01", this.isCrisis)
    this.contactDpaMenu = this.util.getMenuObj(this.menuList, "02", this.isCrisis)
    this.faqMenu = this.util.getMenuObj(this.menuList, "03", this.isCrisis)
    this.loginMenu = this.util.getMenuObj(this.menuList, "04", this.isCrisis)
    this.trackStatusMenu = this.util.getMenuObj(this.menuList, "05", this.isCrisis)
    this.inquiryMenu = this.util.getMenuObj(this.menuList, "06", this.isCrisis)
    this.reqNewDocMenu = this.util.getMenuObj(this.menuList, "1001", this.isCrisis)
    this.statusReqNewDocMenu = this.util.getMenuObj(this.menuList, "1002", this.isCrisis)
    this.banklistMenu = this.util.getMenuObj(this.menuList, "07", this.isCrisis)
    this.fbLoginBtn = this.util.getMenuObj(this.menuList, "08", this.isCrisis)
    this.lineLoginBtn = this.util.getMenuObj(this.menuList, "09", this.isCrisis)
    this.googleLoginBtn = this.util.getMenuObj(this.menuList, "10", this.isCrisis)
    this.regisMenu = this.util.getMenuObj(this.menuList, "11", this.isCrisis)
    this.aboutUsMenu = this.util.getMenuObj(this.menuList, "1000", this.isCrisis)

    if (!gapi.auth2) {
      gapi.load('auth2', function () {
        gapi.auth2.init();
      });
    }

    FB.init({
      appId: '214693200435388',
      cookie: true,
      xfbml: true,
      version: 'v3.1'
    });
    this.util.ShowWaiting(false)

    $.fn.datepicker.defaults.format = "dd/mm/yyyy";

    //$('[data-provide="datepicker"]').after('<i class="fa fa-calendar" style="color: var(--cust-blue)" aria-hidden="true"></i>');
    $('[data-provide="datepicker"]').each(function() {
      if($(this).attr("placeholder") == ""){
        $(this).attr("placeholder", "DD/MM/YYYY");
      }
    });

    // $('[data-provide="datepicker"]').attr("placeholder", "DD/MM/YYYY");
    $(".modal")
      .on("hidden.bs.modal", function (e: any) {
        if ($(".modal:visible").length) {
          $(".modal-backdrop")
            .first()
            .css("z-index", parseInt($(".modal:visible").last().css("z-index")) - 10);
          $("body").addClass("modal-open");
        }
      })
      .on("show.bs.modal", function (e: any) {
        if ($(".modal:visible").length) {
          $(".modal-backdrop.in")
            .first()
            .css("z-index", parseInt($(".modal:visible").last().css("z-index")) + 10);
          $(this).css("z-index", parseInt($(".modal-backdrop.in").first().css("z-index")) + 10);
        }
      });

    $(".user-menu").on("click", function () {
      //thisTs.ClaerActiveTabMenu();
      //if (this.id != null && this.id != undefined && this.id != "") {
      //$(thisTs).addClass("active");
      thisTs.router.navigate([this.id == "" ? thisTs.router.url : ("/mainmenu/" + this.id)]);
      //}
    });

    $("document").on("click", function(){
      $("body").addClass("sidebar-collapse")

    })

    $("#btnmenuMobile").on("click", function(){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    })
  }

  async InitText(urlpath: string) {
    document.body.className = 'h-100 sidebar-collapse'
    //clear active tab menu
    await this.ClaerActiveTabMenu();
    //set active menu
    var targetUrlArray = urlpath.split("/");
    if (targetUrlArray.length > 0) {
      try {

        $("#a_" + targetUrlArray[targetUrlArray.length - 1]).prop("aria-selected", true);
        $("#a_" + targetUrlArray[targetUrlArray.length - 1]).addClass("active");

        
        $("#b_" + targetUrlArray[targetUrlArray.length - 1]).prop("aria-selected", true);
        $("#b_" + targetUrlArray[targetUrlArray.length - 1]).addClass("active");
      }
      catch (e) {

      }
    }

    //if (urlpath == '/mainmenu') {
    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    await this.getUserLoggedIn()

    //
    // }
    
    if (urlpath == '/mainmenu') {
      this.goToIndex()
    }
    this.util.InitValidation()
  }

  setLanguage(language: string) {
    this.cookieData.lang = language
    localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))

    this.i18nService.language = language;
    this.lang = language.substring(0,2)
    this.notiService.langChange(this.lang);
  }

  InitLangImage() {
    var image = <HTMLImageElement>document.getElementById("imgLang");
    var res = this.i18nService.language.split("-");
    image.src = "assets/dist/img/lang/flags_iso/16/" + res[0] + ".png";
  }

  async logout() {
    var dataobj = {};
    dataobj["member_no"] = this.util.GetUserID();
    var data = this.user.logout();

    if (data.status) {
      //  await this.apiService.postnotauthen('account', 'DeleteUserSession', dataobj);
      this.Auth.setLoggedIn(false);
      this.router.navigate(["login"]);
    } else {
      window.alert("Some problem");
    }
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  get title(): string {
    return this.titleService.getTitle();
  }

  ClaerActiveTabMenu() {
    $(".user-menu").each(function () {
      $(this).removeClass("active");
    });
  }

  goToIndex() {
    this.router.navigate(["mainmenu/index"]);
  }
  goToLogin() {
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");      
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    this.router.navigate(["mainmenu/login"]);
  }

  goToProfile() {
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    let url = this.util.baseUrl() + "/mainmenu/profile"
    window.open(url, "_blank")
  }

  goToContactDpa() {
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    let url = 'https://www.dpa.or.th/Inquiries';
    window.open(url, "_blank")
  }

  goToFaq() {
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    let url = 'https://www.dpa.or.th/faq';
    window.open(url, "_blank")
  }

  goToAboutUs(){
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    this.router.navigate(["mainmenu/aboutUs"]);
  }

  goToNews() {
    
    this.router.navigate(["/mainmenu/allNews"])
  }

  newsNotiClick(newsId: string) {

    let news: any = this.notiList.filter((noti: any) => {
      return noti.dpa_newandactivityid == newsId
    })

    if (news != null && news.length > 0) {
      //this.notiList.splice(this.notiList.indexOf(news[0]), 1)
      if (this.notiList[this.notiList.indexOf(news[0])].isRead == null) {
        this.notiList[this.notiList.indexOf(news[0])].isRead = true;
        this.UnreadCount--;
        let ReadList: any = [];
        if (this.cookieData.readNewsList != null && this.cookieData.readNewsList != "") {
          ReadList = JSON.parse(this.cookieData.readNewsList);
        }
        ReadList.push({
          username: this.cookieData.email,
          usernameidno: "",
          newsid: newsId
        });
        this.cookieData.readNewsList = ReadList;
        localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData));

        let req: any = {
          username: this.cookieData.email,
          usernameidno: "",
          newsid: newsId
        };

        this.apiService.postCustomApi("User", "ReadNewsNoti", req);
      }
    }

    // let req: any = {
    //   username: this.cookieData.email,
    //   usernameidno: "",
    //   newsid: newsId
    // }

    // this.apiService.postCustomApi("User", "ReadNewsNoti", req)

    let url = this.util.baseUrl() + "/news/" + newsId
    window.open(url, "_blank")
  }

  async signOut() {
    this.isLoggedIn = false
    this.firstname = ""
    this.lastname = ""
    this.util.ShowWaiting(true)
    await this.util.getIPAddress().subscribe((res: any) => {
      this.util.ShowWaiting(false)
      let req: any = {
        username: this.cookieData.email,
        customerid: this.cookieData.contactid,
        ip: res.json().ip
      }

      this.apiService.postCustomApi("User", "Logout", req)
      this.cookieData.firstname = ""
      this.cookieData.lastname = ""
      this.cookieData.email = ""
      this.cookieData.contactid = ""
      this.cookieData.imgProfileSrc = ""
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
      var auth2 = gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        console.log('User signed out.');
      });

      FB.getLoginStatus(function(response: any) {
        if (response && response.status === 'connected') {
          FB.logout(function(response: any){
            console.log("Logged Out!");
          });
        }
        
      });

      this.goToIndex()
    });
  }

  async goToMenuClick(endPointUrl: string) {
    if ($("aside").hasClass("menuburger")){
      $("aside").toggleClass("menuburger");
      $("#btnmenuMobile img").toggleClass("imgToggle");
    }
    await this.ClaerActiveTabMenu();
    //if (this.id != null && this.id != undefined && this.id != "") {
    $("#a_" + endPointUrl).addClass("active");
    $("#b_" + endPointUrl).addClass("active");
    this.router.navigate(["/mainmenu/" + endPointUrl]);
    //}
  }

  async getUserLoggedIn(){
    if (this.cookieData != null && this.cookieData.contactid != null && this.cookieData.contactid.trim().length != 0) {
      this.isLoggedIn = true
      this.firstname = this.cookieData.firstname
      this.lastname = this.cookieData.lastname
      this.contactId = this.cookieData.contactid
      this.imgProfileSrc = this.cookieData.imgUrl

      let para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_isdisplayoncustomcrmweb=false&dpa_iscrisis=" + this.isCrisis.toString()
      let newsList: any = await this.apiService.get("crmservice", "news", para)

      if (this.cookieData.readNewsList == null) {
        this.notiList = newsList
        this.UnreadCount = newsList.length
      }
      else {
        let readList: any = this.cookieData.readNewsList
        readList.forEach((cn: any) => {
          let toBeRemove: any = newsList.filter((n: any) => {
            return n.dpa_newandactivityid == cn.newsid
          })

          if (toBeRemove != null && toBeRemove.length > 0) {
            //newsList.splice(newsList.indexOf(toBeRemove[0]), 1)
            newsList[newsList.indexOf(toBeRemove[0])].isRead = true;
          }
        });

        this.UnreadCount = newsList.length < readList.length ? 0 : newsList.length - readList.length
        this.notiList = newsList
      }
    }
    else {
      this.isLoggedIn = false
      this.firstname = ""
      this.lastname = ""
      this.contactId = ""
      this.imgProfileSrc = ""

      this.cookieData.firstname = this.firstname
      this.cookieData.lastname = this.lastname
      this.cookieData.contactid = this.contactId
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts